document.addEventListener("latte:init", init);
var gtm = require('./lib/gtm-events');

function init () {

    // if a video is found on page, load the BC script and show the play button on poster images
    bcLoaded = false;

    if($('.video-js').length > 0 && !bcLoaded) {
        $.getScript("//players.brightcove.net/1107601868001/r1lYjyDwux_default/index.min.js")
            .done(function (script) {
                $('.video-inline-poster, .video-inline-video').addClass('bcLoaded');
                bcLoaded = true;
        });
    }

    // if user clicks to play a video, get video id, player and videojs object, call play function
    $('.js-video-action').click(function(e) {
        videoID = $(this).attr('data-video-id');
        videoPlayerID = $('.video-js[data-video-id="'+videoID+'"]').attr('id');
        videoPlayer = videojs(videoPlayerID);
        play(videoPlayer, e);
    });

    // if user clicks to play a video, get video id, player and videojs object, call play function
    $('.media-card.video-inline-video').click(function(e) {
        videoID = $(this).attr('data-video-id');
        videoPlayerID = $('.video-js[data-video-id="'+videoID+'"]').attr('id');
        videoPlayer = videojs(videoPlayerID);
        play(videoPlayer, e);
    });

    // start video, send player data to track function
    function play(clickedVideoPlayer, e) {
        // check target, prevents interfering with BC video controls 
        if(!$(e.target).hasClass('vjs-control') && !$(e.target).is('video')) {
            // pause all playing videos first
            $('.video-js').each(function() {
                $video = $(this);
                videoID = $video.attr('data-video-id');
                videoPlayerID = $video.attr('id');
                videoPlayer = videojs(videoPlayerID);

                $poster = $('.video-inline-poster[data-video-id="'+videoID+'"]');

                videoPlayer.pause();
                $video.removeClass('playing');
                $poster.removeClass('playing');
            });


            videoID = clickedVideoPlayer.mediainfo.id;
            $video = $('.video-js[data-video-id="'+videoID+'"]');

            $poster = $('.video-inline-poster[data-video-id="'+videoID+'"]');

            if(clickedVideoPlayer.paused()) {
                clickedVideoPlayer.play();
                $video.toggleClass('playing');
                $poster.toggleClass('playing');
                track(clickedVideoPlayer);
            } else {
                clickedVideoPlayer.pause();
                $video.toggleClass('playing');
                $poster.toggleClass('playing');
            }
        }
    }

    function track(videoPlayer) {
        videoPlayer._isEventViewed = {};

        videoPlayer.on('play', function () {
            id = videoPlayer.mediainfo.name;
            if (!this._isEventViewed.play) {
                gtm.analyticsEvent('video', 'play', window.location.href);
               this._isEventViewed.play = true;
            }
        });

        videoPlayer.on('timeupdate', function () {
            var currentTime = Number(this.currentTime());
            var duration = Number(this.duration());
            var percentViewed = Math.floor((currentTime / duration) * 100);
            var ev = this._isEventViewed;

            switch (true) {
                case (!ev['25'] && percentViewed >= 25):
                    gtm.analyticsEvent('video', '25%', window.location.href);
                    ev['25'] = true;
                    break;
                case (!ev['50'] && percentViewed >= 50):
                    gtm.analyticsEvent('video', '50%', window.location.href);
                    ev['50'] = true;
                    break;
                case (!ev['75'] && percentViewed >= 75):
                    gtm.analyticsEvent('video', '75%', window.location.href);
                    ev['75'] = true;
                    break;
            }
        });

        videoPlayer.on('ended', function () {
            id = videoPlayer.mediainfo.name;
            if (!this._isEventViewed.ended) {
                gtm.analyticsEvent('video', '100%', window.location.href);
                this._isEventViewed.ended = true;
            }
        });
    }

}



//////////////////
// WEBPACK FOOTER
// ./public/js/video.js
// module id = 94
// module chunks = 0